import { PageHero, Reveal, usePageMeta } from "../components/Common";

const CONTENT = {
  privacy: {
    eyebrow: "Legal",
    title: "Privacy",
    intro: "How English for Leaders handles the information you share through this website.",
    sections: [
      {
        h: "What is collected",
        p: "When you submit the enquiry form, the details you provide are collected: your name, organisation, role, email address, area of interest and message. Nothing else is intentionally collected, and no account is created.",
      },
      {
        h: "How it is used",
        p: "Your details are used for one purpose only: to read and respond to your enquiry. They are not used for marketing lists, newsletters or any automated communication beyond the reply to your message.",
      },
      {
        h: "Storage and sharing",
        p: "Enquiries are stored securely and are never sold, rented or shared with third parties for their own purposes. Email delivery is handled by a transactional email provider solely so your enquiry reaches its destination.",
      },
      {
        h: "Your rights",
        p: "You may ask at any time for your enquiry and associated details to be corrected or deleted. Simply mention it in a message through the same enquiry form and it will be actioned.",
      },
    ],
  },
  terms: {
    eyebrow: "Legal",
    title: "Terms",
    intro: "The terms that govern the use of this website.",
    sections: [
      {
        h: "Informational purpose",
        p: "The content of this website is provided for general information about the advisory services of English for Leaders. It does not constitute professional advice for any specific situation, and no client relationship is formed by using this website.",
      },
      {
        h: "Engagements",
        p: "Any consulting, advisory or workshop engagement is subject to a separate written agreement covering scope, fees and responsibilities. Nothing on this website creates an obligation on either party.",
      },
      {
        h: "Accuracy",
        p: "Reasonable care is taken to keep the information on this website accurate and current. Professional experience and qualifications are represented factually, without invented outcomes, endorsements or testimonials.",
      },
      {
        h: "Intellectual property",
        p: "The text, design and imagery on this website belong to English for Leaders unless otherwise noted, and may not be reproduced without permission.",
      },
    ],
  },
};

const Legal = ({ kind }) => {
  const page = CONTENT[kind] || CONTENT.privacy;

  usePageMeta(`${page.title} — English for Leaders`, page.intro, `/${kind}`);

  return (
    <div data-testid={`legal-${kind}-page`}>
      <PageHero
        testid={`legal-${kind}-hero`}
        eyebrow={page.eyebrow}
        title={page.title}
        intro={page.intro}
      />
      <section className="bg-white">
        <div className="mx-auto max-w-3xl px-6 py-14 lg:py-20">
          <Reveal>
            {page.sections.map((s) => (
              <div key={s.h} className="mb-10">
                <h2 className="font-display text-xl tracking-tight text-navy sm:text-2xl">
                  {s.h}
                </h2>
                <p className="mt-3 text-base leading-relaxed text-charcoal/80">
                  {s.p}
                </p>
              </div>
            ))}
          </Reveal>
        </div>
      </section>
    </div>
  );
};

export default Legal;
